const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/posts/drafts/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/posts/drafts/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    postTo: z.string().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Post Drafts",
      description: "Page title for the post drafts path"
    })
  }
});